export default "__VITE_ASSET__D9$2v4zW__"